import useOpenMasterAccount from "../../../hooks/useOpenMasterAccount";
import { DateDisplay, ProfileDisplay } from "../../../components";
import { TableLoadingRow } from "../../../components/tables/VirtualTable";
import styled from "styled-components";
import { ThemedSpan } from "../../../components/utilities";

const ClientServiceLevelAgreementsManagementDetailTableRowColumn = styled.td`
    width: ${({ width }) => width}%;
    max-width: 0;
    padding: 0.6rem !important;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

const ClientServiceLevelAgreementsDetailTableRow = ({ data, index, style }) => {
    const { height } = style;
    const openMasterAccount = useOpenMasterAccount();

    // do not return a data row when the data has not yet been collected from the backend
    if (index >= data.length) {
        return <TableLoadingRow />;
    }

    const {
        clientServiceLevelAgreementId,
        masterAccountId,
        masterAccount,
        masterAccountReference,
        masterAccountStatus,
        serviceLevelAgreement,
        serviceLevelAgreementStatus,
        serviceLevelAgreementStatusDate,
        adviserId,
        anniversary,
        frequency,
        consentPublishedDate,
        consentSignedDate,
        latestReviewDate,
        latestReviewStatus,

    } = data[index];

    const handleOpenMasterAccount = (e) => {
        if (e && typeof e.preventDefault === "function") {
            e.preventDefault();
        }
        openMasterAccount(masterAccountId, { suffix: "serviceterms" });
    };

    return (
        <tr style={{ height }}>
            {/* Client Name Display */}
            <ClientServiceLevelAgreementsManagementDetailTableRowColumn width={25} style={{ height }}>
                <p className="m-0 lh-1">
                    <a href={`/client/${masterAccountId}/reviews`} onClick={handleOpenMasterAccount}>
                        <span>
                            {masterAccountReference} - {masterAccount}
                        </span>
                    </a> 
                    <br />
                    <ThemedSpan variant="muted" className="fs-smallest">{masterAccountStatus}</ThemedSpan>
                </p>
            </ClientServiceLevelAgreementsManagementDetailTableRowColumn>
            <ClientServiceLevelAgreementsManagementDetailTableRowColumn>
                {adviserId ? (<ProfileDisplay userId={adviserId} />) : (<span>-</span>)}
            </ClientServiceLevelAgreementsManagementDetailTableRowColumn>
            <ClientServiceLevelAgreementsManagementDetailTableRowColumn>
                 <p className="m-0 lh-1">
                    {serviceLevelAgreementStatus}
                    <br />
                    <ThemedSpan variant="muted" className="fs-smallest">{serviceLevelAgreement}</ThemedSpan>
                 </p> 
            </ClientServiceLevelAgreementsManagementDetailTableRowColumn>
            <ClientServiceLevelAgreementsManagementDetailTableRowColumn width={7.5}>
                {serviceLevelAgreementStatusDate ? (
                        <span><DateDisplay>{serviceLevelAgreementStatusDate}</DateDisplay></span> 
                ) : (<span>-</span>)}
            </ClientServiceLevelAgreementsManagementDetailTableRowColumn>
            <ClientServiceLevelAgreementsManagementDetailTableRowColumn width={7.5}>
                 <p className="m-0 lh-1">
                    {anniversary}
                    <br />
                    <ThemedSpan variant="muted" className="fs-smallest">{frequency}</ThemedSpan>
                 </p> 
            </ClientServiceLevelAgreementsManagementDetailTableRowColumn>
            <ClientServiceLevelAgreementsManagementDetailTableRowColumn width={7.5}>
                {consentPublishedDate ? (
                        <span><DateDisplay>{consentPublishedDate}</DateDisplay></span> 
                ) : (<span>-</span>)}
            </ClientServiceLevelAgreementsManagementDetailTableRowColumn>
            <ClientServiceLevelAgreementsManagementDetailTableRowColumn width={7.5}>
                {consentSignedDate ? (
                        <span><DateDisplay>{consentSignedDate}</DateDisplay></span> 
                ) : (<span>-</span>)}
            </ClientServiceLevelAgreementsManagementDetailTableRowColumn>
            <ClientServiceLevelAgreementsManagementDetailTableRowColumn width={7.5}>
                {latestReviewDate ? (
                    <p className="m-0 lh-1">
                        <span><DateDisplay>{latestReviewDate}</DateDisplay></span> 
                        <br />
                        <ThemedSpan variant="muted" className="fs-smallest">{latestReviewStatus}</ThemedSpan>
                    </p>
                ) : (<span>-</span>)}
            </ClientServiceLevelAgreementsManagementDetailTableRowColumn>
        </tr>
    );
};

export default ClientServiceLevelAgreementsDetailTableRow;
